import { useQuery } from '@apollo/client';
import { GET_PROPOSAL_DEAL_TYPES_OPTIONS } from '../api';
import { SelectOption } from '../../../global';

export function useProposalDealTypes() {
  const { data, loading } = useQuery<{ proposalDealTypes: SelectOption[] }>(GET_PROPOSAL_DEAL_TYPES_OPTIONS);

  return {
    isLoading: loading,
    options: data?.proposalDealTypes ?? [],
  };
}
